// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'

import '@/icons' // api: http://www.iconfont.cn/
import store from './store'

// 全局配置
import '@/assets/scss/reset.scss'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import echarts from 'echarts'
import './plugins/VueQuillEditor.js'
import JSEncrypt from 'JSEncrypt'
Vue.prototype.$echarts = echarts
Vue.prototype.$getRsaCode = function (str, key) { // 注册方法
  let pubKey = key;// ES6 模板字符串 引用 rsa 公钥
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let data = encryptStr.encrypt(str.toString());  // 进行加密
  return data;
}
Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'medium' })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js